export default {
    "AF": {
        "name": "Afghanistan"
    },
    "AL": {
        "name": "Albanië"
    },
    "DZ": {
        "name": "Algerije"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua en Barbuda"
    },
    "AR": {
        "name": "Argentinië"
    },
    "AM": {
        "name": "Armenië"
    },
    "AU": {
        "name": "Australië"
    },
    "AZ": {
        "name": "Azerbeidzjan"
    },
    "BS": {
        "name": "Bahama's"
    },
    "BH": {
        "name": "Bahrein"
    },
    "BD": {
        "name": "Bangladesh"
    },
    "BB": {
        "name": "Barbados"
    },
    "BE": {
        "name": "België"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benin"
    },
    "BT": {
        "name": "Bhutan"
    },
    "BO": {
        "name": "Bolivia"
    },
    "BA": {
        "name": "Bosnië en Herzegovina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brazilië"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bulgarije"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BI": {
        "name": "Burundi"
    },
    "KH": {
        "name": "Cambodja"
    },
    "CA": {
        "name": "Canada"
    },
    "CF": {
        "name": "Centraal-Afrikaanse Republiek"
    },
    "CL": {
        "name": "Chili"
    },
    "CN": {
        "name": "China"
    },
    "CO": {
        "name": "Colombia"
    },
    "KM": {
        "name": "Comoren"
    },
    "CG": {
        "name": "Congo-Brazzaville"
    },
    "CD": {
        "name": "Congo-Kinshasa"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "CU": {
        "name": "Cuba"
    },
    "CY": {
        "name": "Cyprus"
    },
    "DK": {
        "name": "Denemarken"
    },
    "DJ": {
        "name": "Djibouti"
    },
    "DM": {
        "name": "Dominica"
    },
    "DO": {
        "name": "Dominicaanse Republiek"
    },
    "DE": {
        "name": "Duitsland"
    },
    "EC": {
        "name": "Ecuador"
    },
    "EG": {
        "name": "Egypte"
    },
    "SV": {
        "name": "El Salvador"
    },
    "GQ": {
        "name": "Equatoriaal-Guinea"
    },
    "ER": {
        "name": "Eritrea"
    },
    "EE": {
        "name": "Estland"
    },
    "ET": {
        "name": "Ethiopië"
    },
    "FJ": {
        "name": "Fiji"
    },
    "PH": {
        "name": "Filipijnen"
    },
    "FI": {
        "name": "Finland"
    },
    "FR": {
        "name": "Frankrijk"
    },
    "GA": {
        "name": "Gabon"
    },
    "GM": {
        "name": "Gambia"
    },
    "GE": {
        "name": "Georgië"
    },
    "GH": {
        "name": "Ghana"
    },
    "GD": {
        "name": "Grenada"
    },
    "GR": {
        "name": "Griekenland"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guinee"
    },
    "GW": {
        "name": "Guinee-Bissau"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haïti"
    },
    "HN": {
        "name": "Honduras"
    },
    "HU": {
        "name": "Hongarije"
    },
    "IE": {
        "name": "Ierland"
    },
    "IS": {
        "name": "IJsland"
    },
    "IN": {
        "name": "India"
    },
    "ID": {
        "name": "Indonesië"
    },
    "IQ": {
        "name": "Irak"
    },
    "IR": {
        "name": "Iran"
    },
    "IL": {
        "name": "Israël"
    },
    "IT": {
        "name": "Italië"
    },
    "CI": {
        "name": "Ivoorkust"
    },
    "JM": {
        "name": "Jamaica"
    },
    "JP": {
        "name": "Japan"
    },
    "YE": {
        "name": "Jemen"
    },
    "JO": {
        "name": "Jordanië"
    },
    "CV": {
        "name": "Kaapverdië"
    },
    "CM": {
        "name": "Kameroen"
    },
    "KZ": {
        "name": "Kazachstan"
    },
    "KE": {
        "name": "Kenia"
    },
    "KG": {
        "name": "Kirgizië"
    },
    "KI": {
        "name": "Kiribati"
    },
    "KW": {
        "name": "Koeweit"
    },
    "HR": {
        "name": "Kroatië"
    },
    "LA": {
        "name": "Laos"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LV": {
        "name": "Letland"
    },
    "LB": {
        "name": "Libanon"
    },
    "LR": {
        "name": "Liberia"
    },
    "LY": {
        "name": "Libië"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Litouwen"
    },
    "LU": {
        "name": "Luxemburg"
    },
    "MG": {
        "name": "Madagaskar"
    },
    "MW": {
        "name": "Malawi"
    },
    "MV": {
        "name": "Maldiven"
    },
    "MY": {
        "name": "Maleisië"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malta"
    },
    "MA": {
        "name": "Marokko"
    },
    "MH": {
        "name": "Marshalleilanden"
    },
    "MR": {
        "name": "Mauritanië"
    },
    "MU": {
        "name": "Mauritius"
    },
    "MX": {
        "name": "Mexico"
    },
    "FM": {
        "name": "Micronesia"
    },
    "MD": {
        "name": "Moldavië"
    },
    "MC": {
        "name": "Monaco"
    },
    "MN": {
        "name": "Mongolië"
    },
    "ME": {
        "name": "Montenegro"
    },
    "MZ": {
        "name": "Mozambique"
    },
    "MM": {
        "name": "Myanmar"
    },
    "NA": {
        "name": "Namibië"
    },
    "NR": {
        "name": "Nauru"
    },
    "NL": {
        "name": "Nederland"
    },
    "NP": {
        "name": "Nepal"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NZ": {
        "name": "Nieuw-Zeeland"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "KP": {
        "name": "Noord-Korea"
    },
    "MK": {
        "name": "Noord-Macedonië"
    },
    "NO": {
        "name": "Noorwegen"
    },
    "UG": {
        "name": "Oeganda"
    },
    "UA": {
        "name": "Oekraïne"
    },
    "UZ": {
        "name": "Oezbekistan"
    },
    "OM": {
        "name": "Oman"
    },
    "AT": {
        "name": "Oostenrijk"
    },
    "TL": {
        "name": "Oost-Timor"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Papoea-Nieuw-Guinea"
    },
    "PY": {
        "name": "Paraguay"
    },
    "PE": {
        "name": "Peru"
    },
    "PL": {
        "name": "Polen"
    },
    "PT": {
        "name": "Portugal"
    },
    "QA": {
        "name": "Qatar"
    },
    "RO": {
        "name": "Roemenië"
    },
    "RU": {
        "name": "Rusland"
    },
    "RW": {
        "name": "Rwanda"
    },
    "KN": {
        "name": "Saint Kitts en Nevis"
    },
    "LC": {
        "name": "Saint Lucia"
    },
    "VC": {
        "name": "Saint Vincent en de Grenadines"
    },
    "SB": {
        "name": "Salomonseilanden"
    },
    "WS": {
        "name": "Samoa"
    },
    "SM": {
        "name": "San Marino"
    },
    "SA": {
        "name": "Saoedi-Arabië"
    },
    "ST": {
        "name": "Sao Tomé en Principe"
    },
    "SN": {
        "name": "Senegal"
    },
    "RS": {
        "name": "Servië"
    },
    "SC": {
        "name": "Seychellen"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "SG": {
        "name": "Singapore"
    },
    "SI": {
        "name": "Slovenië"
    },
    "SK": {
        "name": "Slowakije"
    },
    "SD": {
        "name": "Soedan"
    },
    "SO": {
        "name": "Somalië"
    },
    "ES": {
        "name": "Spanje"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "SR": {
        "name": "Suriname"
    },
    "SZ": {
        "name": "Swaziland"
    },
    "SY": {
        "name": "Syrië"
    },
    "TJ": {
        "name": "Tadzjikistan"
    },
    "TZ": {
        "name": "Tanzania"
    },
    "TH": {
        "name": "Thailand"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trinidad en Tobago"
    },
    "TD": {
        "name": "Tsjaad"
    },
    "CZ": {
        "name": "Tsjechië"
    },
    "TN": {
        "name": "Tunesië"
    },
    "TR": {
        "name": "Turkije"
    },
    "TM": {
        "name": "Turkmenistan"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UY": {
        "name": "Uruguay"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "AE": {
        "name": "Verenigde Arabische Emiraten"
    },
    "US": {
        "name": "Verenigde Staten"
    },
    "GB": {
        "name": "Verenigd Koninkrijk"
    },
    "VN": {
        "name": "Vietnam"
    },
    "BY": {
        "name": "Wit-Rusland"
    },
    "ZM": {
        "name": "Zambia"
    },
    "ZW": {
        "name": "Zimbabwe"
    },
    "ZA": {
        "name": "Zuid-Afrika"
    },
    "KR": {
        "name": "Zuid-Korea"
    },
    "SS": {
        "name": "Zuid-Soedan"
    },
    "SE": {
        "name": "Zweden"
    },
    "CH": {
        "name": "Zwitserland"
    }
}